import { ChangeDetectionStrategy, Component, inject, OnDestroy, Signal } from '@angular/core';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { Toast } from '@shared/models/toast';
import { ToastStoreService } from '@shared/stores/toast-store.service';

@Component({
  selector: 'evland-toasts-area',
  templateUrl: './toasts-area.component.html',
  styleUrls: [ './toasts-area.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgbToast,
  ],
})
export class ToastsAreaComponent implements OnDestroy {
  private toast = inject(ToastStoreService);

  toasts: Signal<Toast[]>;

  constructor() {
    this.toasts = this.toast.listS;
  }

  ngOnDestroy(): void {
    this.toast.clear();
  }

  removeToast(toast: Toast): void {
    this.toast.removeFromList(toast.id);
  }
}
